import { connect } from 'react-redux';
import pageHoc from 'hocs/pageHoc';
import Inbox, { mapStateToProps, mapDispatchToProps } from './Inbox';
import compose from '../../helpers/compose';
import withMainLayout from '../../hocs/withMainLayout';

const enhance = compose(withMainLayout, pageHoc({ title: 'Inbox' }), connect(mapStateToProps, mapDispatchToProps));
export default enhance(Inbox);
